import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'bootstrap'
import Vuelidate from 'vuelidate'

import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css"
Vue.component('multiselect', Multiselect)

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFolderOpen, faAngleLeft, faFileImport, faFile, faEdit, faSave, faTrashAlt, faPlusCircle, faWindowClose, faUpload } from '@fortawesome/free-solid-svg-icons'

library.add(faFolderOpen, faAngleLeft, faFileImport, faFile, faEdit, faSave, faUpload, faTrashAlt, faPlusCircle, faWindowClose)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuelidate)
Vue.use(Toast)

import './styles/base.scss'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
